import { NewsPostList, NewsSinglePost } from 'services/news/types';
import { createCmsAssetUrl } from 'config/cms';

export const normalizePost = (raw: any): NewsPostList | NewsSinglePost => ({
  ...raw,
  image: createCmsAssetUrl(raw.image.filename_disk),
});
